import {memo} from 'react';

import styled from 'styled-components';

import ImageWithAlt from '~/shared/components/ImageWithAlt';
import {FlexCenter, FlexCenterVertically} from '~/shared/theme/FlexLayout';
import {getLocalizationService} from '~/shared/services/localisationService';
import {bodyRegular, headingS} from '~/shared/theme/typography';
import PieButton from '~/shared/theme/pie/PieButton';

import sentPassImgSrc from './assets/sendThanksLarge.png';

const Root = styled(FlexCenterVertically)`
  padding-top: 12px;
  flex-direction: column;
  width: 100%;
  text-align: center;
`;

const StyledImg = styled(ImageWithAlt).attrs({
  src: sentPassImgSrc,
  alt: 'Password sent',
})`
  width: 200px;
  height: 200px;
`;

const TextWrapper = styled(FlexCenter)`
  flex-direction: column;
  gap: 8px;
  margin-bottom: 40px;
`;

const Title = styled.h2.attrs({id: 'modal-title'})`
  ${headingS}
`;

const SubTitle = styled.p`
  ${bodyRegular}
`;

const StyledPieButton = styled(PieButton)`
  width: 100%;
`;

type ResentPasswordViewProps = {
  onBackClick?: () => void;
};

const ResentPasswordView = ({onBackClick}: ResentPasswordViewProps) => {
  const {t} = getLocalizationService();
  return (
    <Root>
      <StyledImg />
      <TextWrapper>
        <Title>{t('reset_email_sent')}</Title>
        <SubTitle>{t('just_click_the_link_inside')}</SubTitle>
      </TextWrapper>
      <StyledPieButton variant="primaryLarge" onClick={onBackClick}>{t('got_it')}</StyledPieButton>
    </Root>
  );
};

export default memo(ResentPasswordView);
